export const CANCEL_MSG = "canceled";
// The worst assumed upload speed for calculating TIMEOUT (1.5 mb in 1 minute)
export const SPEED = 1500000 / 60000;
export const MIN_TIMEOUT = 60000;
export const MAX_FILE_SIZE = 500;
